import React, { useState, useEffect, useRef } from 'react';
import styles from './HomeDetails.scss';
import Config from '../../utils/Config';
import RequestManager from '../../utils/RequestManager';
import PropertyRequest from '../../utils/PropertyRequest';
import HomeCard from '../HomeCard';
import HomeCardEmpty from '../HomeCardEmpty';
import IHome from '../../interfaces/IHome';
import HomeCardSmall from '../HomeCardSmall';
import WindowDimensionsProvider, { useWindowDimensions } from '../../components/WindowDimensionsProvider';
import Empty from '../Empty';

export interface IHomeDetailsProps {
    className?: string;
    uuid: string;
    onLoaded: (home: IHome) => void;
}

const HomeDetails: React.FC<React.PropsWithChildren<IHomeDetailsProps>> = ({ uuid = null, className = '', onLoaded = () => {} }) => {
    const [data, setData] = React.useState(null);
    const { width, height } = useWindowDimensions();

    React.useEffect(() => {
        if (uuid) {
            PropertyRequest.getDetails(uuid).then((data) => {
                setData(data);
                onLoaded(data);
            });
        }
    }, []);

    const useSmallCard = (height < 860 && width > 993) || width <= 993;

    return (
        // <WindowDimensionsProvider>
        // </WindowDimensionsProvider>
        (<div className={styles.homeDetails + ' ' + className}>
            {useSmallCard ? data ? <HomeCardSmall data={data} /> : <Empty /> : data ? <HomeCard data={data} /> : <HomeCardEmpty view="list" />}
        </div>)
    );
};

export default HomeDetails;
